import { FC } from 'react';
import styled from 'styled-components';

export interface IProps extends IntrinsicProps {
  /** Text color. Defaults to theme.designToken.Neutral900 */
  color?: string;
  /** Variation of Heading */
  variation: Variation;
}

const H1 = styled.h1<IProps>`
  color: ${props => (props.color ? props.color : props.theme.designToken.neutral900)};
  font: ${props => props.theme.designToken.headingH1};
  letter-spacing: ${props => props.theme.designToken.letterSpacing0};
  text-decoration: ${props => props.theme.designToken.textDecorationNone};
`;

const H2 = styled.h2<IProps>`
  color: ${props => (props.color ? props.color : props.theme.designToken.neutral900)};
  font: ${props => props.theme.designToken.headingH2};
  letter-spacing: ${props => props.theme.designToken.letterSpacing0};
  text-decoration: ${props => props.theme.designToken.textDecorationNone};
`;

const H3 = styled.h3<IProps>`
  color: ${props => (props.color ? props.color : props.theme.designToken.neutral900)};
  font: ${props =>
    props.variation === 'H3 Italic' ? props.theme.designToken.headingH3Italic : props.theme.designToken.headingH3};
  letter-spacing: ${props => props.theme.designToken.letterSpacing0};
  text-decoration: ${props => props.theme.designToken.textDecorationNone};
  font-style: ${props => (props.variation === 'H3 Italic' ? 'italic' : 'normal')};
`;

type Variation = 'H1' | 'H2' | 'H3' | 'H3 Italic';

export const Heading: FC<IProps> = ({ color, variation, children, ...props }) => {
  switch (variation) {
    case 'H1':
      return (
        <H1 color={color} variation="H1" {...props}>
          {children}
        </H1>
      );
    case 'H2':
      return (
        <H2 color={color} variation="H2" {...props}>
          {children}
        </H2>
      );
    case 'H3':
      return (
        <H3 color={color} variation="H3" {...props}>
          {children}
        </H3>
      );
    case 'H3 Italic':
      return (
        <H3 color={color} variation="H3 Italic" {...props}>
          {children}
        </H3>
      );
  }
};
